(ns storrito.fabricjs.center)

(defn center-x
  "Centers the object on the x axis."
  [object-data canvas-size]
  (- (/ (:width canvas-size) 2)
     (* (:width object-data)
        (:scaleX object-data)
        0.5)))

(defn center-y
  "Centers the object on the y axis."
  [object-data canvas-size]
  (- (/ (:height canvas-size) 2)
     (* (:height object-data)
        (:scaleY object-data)
        0.5)))

(defn center
  "Centers the object in the middle of the canvas."
  [object-data canvas-size]
  (assoc object-data
         :top (center-y object-data
                        canvas-size)
         :left (center-x object-data
                         canvas-size)))
